import React, { FC } from "react";

import {
    AlfaRomeo,
    Audi,
    Bmw,
    Citroen,
    Honda,
    Hyundai,
    Lexus,
    Mercedes,
    Mini,
    Mitsubishi,
    Nissan,
    Opel,
    Peugeot,
    Renault,
    Skoda,
    Smart,
    Tesla,
    Toyota,
    Volkswagen,
    Volvo,
} from "@/assets/icons/tariffication/brands";
import { isNotEmpty } from "@/core/string";

type BrandLogoProps = {
    brand: string | null;
};

const BrandLogo: FC<BrandLogoProps> = ({ brand }) => {
    if (isNotEmpty(brand)) {
        switch (brand.replace(" ", "").toLocaleLowerCase()) {
            case "alfaromeo":
                return <AlfaRomeo />;
            case "audi":
                return <Audi />;
            case "bmw":
                return <Bmw />;
            case "citroen":
                return <Citroen />;
            case "honda":
                return <Honda />;
            case "hyundai":
                return <Hyundai />;
            case "lexus":
                return <Lexus />;
            case "mercedes":
                return <Mercedes />;
            case "mini":
                return <Mini />;
            case "mitsubishi":
                return <Mitsubishi />;
            case "nissan":
                return <Nissan />;
            case "opel":
                return <Opel />;
            case "peugeot":
                return <Peugeot />;
            case "renault":
                return <Renault />;
            case "skoda":
                return <Skoda />;
            case "smart":
                return <Smart />;
            case "tesla":
                return <Tesla />;
            case "toyota":
                return <Toyota />;
            case "volkswagen":
                return <Volkswagen />;
            case "volvo":
                return <Volvo />;
            case "default":
                return <></>;
        }
    }
    return <></>;
};

export default BrandLogo;
